import request from "../plugins/axios";

export function workMoment (params) {
    return request({
        url: '/workMoment/index',
        method: 'GET',
        params
    })
}
